import React from 'react';
import { useSelector } from 'react-redux';
import { MenuOptionsContainer, MenuText } from './MenuOptionsComponents';
import routes from '../../../router/routes';

const MenuOptions = () => {
  const isLoggedin = useSelector((state) => state.admin.isLoggedin);
  return (
    <MenuOptionsContainer loggedIn={isLoggedin}>
      <MenuText
        activeStyle={{
          opacity: '1 !important',
          color: '#fff',
          opacity: 1,
          fontWeight: '500',
        }}
        to={routes.terms}>
        Términos de uso
      </MenuText>
      <MenuText
        activeStyle={{
          opacity: '1 !important',
          color: '#fff',
          opacity: 1,
          fontWeight: '500',
        }}
        to={routes.privacy}>
        Política de privacidad
      </MenuText>
      <MenuText
        activeStyle={{
          opacity: '1 !important',
          color: '#fff',
          opacity: 1,
          fontWeight: '500',
        }}
        to={routes.about}>
        Acerca de la App
      </MenuText>
    </MenuOptionsContainer>
  );
};

export default MenuOptions;
